module.exports = require("./teo-KE.d.ts");